import { useForm } from '@moniebook-web/components/atoms/form';
import { Textarea as DefaultTextarea } from '@moniebook-web/components/atoms/form/textarea';
import { type ComponentProps, type ForwardedRef, forwardRef } from 'react';
type Props = ComponentProps<typeof DefaultTextarea> & {
    containerClassName?: string;
};

function TextareaWithRef(props: Props, ref: ForwardedRef<HTMLTextAreaElement>) {
    const { watch } = useForm();
    const { containerClassName, ...rest } = props;

    const noteText = watch(props.name ?? '') ?? '';

    const MAX_INPUT_COUNT = Number(props.rules?.maxLength ?? 0);

    return (
        <div className={containerClassName}>
            <DefaultTextarea
                defaultValue={rest.defaultValue ?? noteText}
                {...rest}
                ref={ref}
                hideCharacterCount
            />
            {!props.hideCharacterCount && (
                <p className='text-12 text-content-subtext-alternative'>
                    {MAX_INPUT_COUNT - (noteText?.length ?? 0)} characters left
                </p>
            )}
        </div>
    );
}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(TextareaWithRef);
